export default "__VITE_ASSET__DJq3R2wu__"